export default __webpack_public_path__ + "static/media/I0002.31ad1239.png";